import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import classes from "./Activities.module.css";
import styles from "../../champions/Champions.module.css";
import { testUrl } from "../BaseData";
import { FaStar, FaTrophy, FaMedal } from "react-icons/fa";

const IqtidorlilarVaChempionlar = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [champions, setChampions] = useState([]);

  // Fetch data from API
  useEffect(() => {
    setLoading(true);
    setError(null);
    
    axios
      .get(testUrl + "/api/champion-students/")
      .then((response) => {
        setChampions(response.data);
      })
      .catch(() => setError("Ma'lumotlarni yuklashda xatolik"))
      .finally(() => setLoading(false));
  }, [i18n.language]);

  // Determine the trophy icon and stars based on description
  const renderTrophyIconAndStars = (description) => {
    if (!description) return { icon: <FaTrophy className={styles.icon} />, stars: 2 };

    const lowerCaseDescription = description.toLowerCase();
    if (lowerCaseDescription.includes("oltin")) {
      return {
        icon: <FaMedal className={styles.icon} style={{ color: "#FFD700" }} />,
        stars: 5,
      };
    } else if (lowerCaseDescription.includes("kumush")) {
      return {
        icon: <FaMedal className={styles.icon} style={{ color: "#C0C0C0" }} />,
        stars: 4,
      };
    } else if (lowerCaseDescription.includes("bronza")) {
      return {
        icon: <FaMedal className={styles.icon} style={{ color: "#CD7F32" }} />,
        stars: 3,
      };
    } else {
      return {
        icon: <FaTrophy className={styles.icon} />,
        stars: 2,
      };
    }
  };

  // Render stars dynamically
  const renderStars = (count) =>
    Array.from({ length: count }).map((_, idx) => (
      <FaStar key={idx} className={styles.star} />
    ));

  if (loading) return <div>Yuklanmoqda...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className={classes["mainContainer"]}>
      <div data-aos="fade-up" className={classes["container"]}>
        <h1 className={classes["page-title"]}>{t("Iqtidorlilar va chempionlar")}</h1>
        <div className={styles.championGrid}>
          {champions.map((champion) => {
            const { icon, stars } = renderTrophyIconAndStars(
              champion[`description_${i18n.language}`]
            );
            return (
              <div key={champion.id} className={styles.championCard}>
                <div className={styles.cardHeader}>
                  <img
                    src={champion.image}
                    alt={`${champion[`name_${i18n.language}`]} ${champion[`surname_${i18n.language}`]}`}
                    className={styles.championImage}
                  />
                  <div className={styles.cardIcons}>{icon}</div>
                </div>
                <h3 className={styles.championName}>
                  {champion[`name_${i18n.language}`]} {champion[`surname_${i18n.language}`]}
                </h3>
                <div
                  dangerouslySetInnerHTML={{
                    __html: champion[`description_${i18n.language}`],
                  }}
                />
                <div className={styles.stars}>{renderStars(stars)}</div>
              </div>
            );
          })}
        </div>
      </div>
      <div className={classes.sidebar}>
        <h3>{t("Talabalarga")}</h3>
        <ul>
          <li onClick={() => navigate("/baseactivities/talabalar-hayoti/")}>
            {t("Talabalar hayoti")}
          </li>
          <li onClick={() => navigate("/activity/talabalarga/karyera/")}>
            {t("Karyera")}
          </li>
          <li onClick={() => navigate("/university-union")}>
            {t("universityUnion")}
          </li>
          <li onClick={() => navigate("/activity/talabalarga/talabalar-turar-joyi")}>
            {t("Talabalar turar joyi")}
          </li>
          <li className={classes.active}>
            {t("Iqtidorlilar va chempionlar")}
          </li>
          <li onClick={() => navigate("/activity/talabalarga/stipendiantlar")}>
            {t("Stipendiantlar")}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default IqtidorlilarVaChempionlar; 